import config from './config-complicated.xml';
import tasks from './tasks.json';
import annotation from './annotations/0.json';

export const Nested = { config, tasks, annotation };
